import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { useTranslation } from 'react-i18next'
import { HiArrowLeft } from 'react-icons/hi'
import SEO from '../../components/SEO/SEO'
import { seoBreadcrumbTriple } from '../../utils/seoUtils'
import { useLocalizedLink } from '../../hooks/useLocalizedLink'
import attestationMarkdown from '../../content/documents/Attestatsionnye_trebovaniya_SUMA.md?raw'
import '../Charter/Charter.css'

const markdownComponents = {
  table: ({ children, ...props }) => (
    <div className="charter-table-scroll">
      <table {...props}>{children}</table>
    </div>
  ),
}

function AttestationGuidelines() {
  const { t } = useTranslation()
  const getLocalizedLink = useLocalizedLink()

  const breadcrumbItems = useMemo(
    () =>
      seoBreadcrumbTriple(
        t('common.home'),
        t('common.documents'),
        'documents',
        t('documents.attestationGuidelinesPage.breadcrumb'),
        'documents/attestation-guidelines'
      ),
    [t]
  )

  return (
    <div className="charter-page">
      <SEO
        title={t('documents.attestationGuidelinesPage.title')}
        description={t('documents.attestationGuidelinesPage.description')}
        breadcrumbItems={breadcrumbItems}
      />
      <div className="container charter-container">
        <Link to={getLocalizedLink('/documents')} className="charter-back-link">
          <HiArrowLeft aria-hidden />
          {t('documents.attestationGuidelinesPage.back')}
        </Link>

        <article className="charter-document">
          <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
            {attestationMarkdown}
          </ReactMarkdown>
        </article>
      </div>
    </div>
  )
}

export default AttestationGuidelines
